import React from 'react'
import './client-booking-list.css'
import BlackButton from '../basic/button'

const Heloo = () => {
  window.alert('Mensagem de Teste')
}

const agenda = () => {
  return (
    <div>
      <p>Horários Disponíveis</p>
      
      <div className="button-booking">
          <BlackButton Label={'09:00'} Action={Heloo} />
      </div>

      <div className="button-booking">
          <BlackButton Label={'10:00'} Action={Heloo} />
      </div>

      <div className="button-booking">
          <BlackButton Label={'11:00'} Action={Heloo} />
      </div>
    </div>
  )
}

export default agenda